// src/services/adminApi.js
import { http } from './http'
import { STORAGE_KEYS } from '../config/apiConfig'

function adminHeaders() {
  const id = localStorage.getItem(STORAGE_KEYS.adminKey)
  const secret = localStorage.getItem(STORAGE_KEYS.adminSecret)
  return id && secret ? { 'X-Admin-Key': id, 'X-Admin-Secret': secret } : {}
}

// Create a new researcher key
export function generateKey({ role = 'researcher', ttl_days } = {}) {
  const body = { action: 'create', role }
  if (typeof ttl_days === 'number') body.ttl_days = ttl_days
  return http.post('/v1/admin/keys', { body, headers: adminHeaders(), auth: 'none' })
}

// (Optional) List keys
export function listKeys() {
  return http.post('/v1/admin/keys', { body: { action: 'list' }, headers: adminHeaders(), auth: 'none' })
}

// (Optional) Revoke a key
export function revokeKey(keyId) {
  return http.post('/v1/admin/keys', { body: { action: 'revoke', keyId }, headers: adminHeaders(), auth: 'none' })
}
